import React from "react";
var Posts = [
  {
    title:
      "Los firmó y no los cumplió: 8 compromisos de la campaña de Peña Nieto que se cancelaron este sexenio",
    sumario:
      "De los 266 compromisos que Enrique Peña Nieto firmó como candidato presidencial, ocho se cancelaron o definitivamente no se cumplirán en este sexenio, ya sea por falta de presupuesto, inseguridad, protestas de pobladores o, incluso, según el gobierno federal, por responsabilidad de los estados. ",
    author: "Redacción Animal Político",
    slug: "compromisos-cancelados",
    fecha: "2 de septiembre, 2018",
    photo: {
      uri: require("../img/cierre.jpg"),
      simplecredit: true,
      author: {
        name: "Universidad Autónoma de Yucatán",
        url: "https://twitter.com/santiago_arau"
      }
    },
    content: (
      <div>
        <p>
          De los 266 compromisos que Enrique Peña Nieto firmó como candidato
          presidencial, ocho se cancelaron o definitivamente no se cumplirán en
          este sexenio, ya sea por falta de presupuesto, inseguridad, protestas
          de pobladores o, incluso, según el gobierno federal, por
          responsabilidad de los estados.
        </p>
        <p>
          La Comisión Nacional del Agua (Conagua), la Secretaría de Economía,
          Pemex, la Secretaría de Comunicaciones y Transportes (SCT) y la
          Secretaría de Turismo respondieron en solicitudes de información
          pública que motivó la cancelación de ocho promesas presidenciales.
        </p>
        <p>
          <strong>Tren transpeninsular</strong>
        </p>
        <p>
          Ahora que es tan comentado el tema del Tren Maya que propone el
          presidente electo, Andrés Manuel López Obrador, el presidente Peña
          Nieto también planteó una obra de ese tipo para la zona sur del país,
          el Tren Transpeninsular desde Mérida, Yucatán, hasta Punta Venado,
          Quintana Roo, con una longitud de 336 kilómetros, y una inversión
          estimada de 16 mil millones de pesos.
        </p>
        <p>
          En diciembre de 2012, al hablar del proyecto, Peña Nieto dijo que,
          además de permitir un traslado de pasajeros más seguro y rápido, la
          obra facilitaría el comercio y el tránsito de mercancías desde Yucatán
          hacia Quintana Roo.
        </p>
        <p>
          <strong>
            "Significará conectividad, más turismo, empleo, así como
            oportunidades de crecimiento para esta región. Es una vía directa
            hacia el México próspero"
          </strong>, dijo el presidente.
        </p>
        <p>
          En el Programa Nacional de Infraestructura, el gobierno federal
          detalló que la “construcción de este tren de pasajeros será un
          proyecto que detone la movilización de pasajeros en la península de
          Yucatán, así mismo será fundamental para el desarrollo y expansión del
          turismo en la región”. Y anunció que su construcción iniciaría en 2014
          con una inversión de <strong>17,954 millones de pesos </strong>y
          finalizaría en 2017.
        </p>
        <p>
          Sin embargo, el 30 de enero de 2015, quien era secretario de Hacienda,
          Luis Videgaray,{" "}
          <a
            target="_blank"
            href="https://www.animalpolitico.com/2015/01/por-ajuste-al-gasto-en-mexico-adios-al-tren-transpeninsular-y-al-mexico-queretaro/"
          >
            anunció la cancelación del tren
          </a>. El funcionario argumentó que cancelar la obra respondía a las
          medidas de austeridad para enfrentar un escenario económico
          internacional adverso, con la caída del precio del petróleo y la
          desaceleración en algunas regiones.
        </p>
        <p>
          La obra, que correspondía realizar a la Secretaría de Comunicaciones y
          Transportes, no se volvió a presupuestar en el gobierno de Enrique
          Peña Nieto.
        </p>
        <p>
          <strong>Tramo de red ferroviaria</strong>
        </p>
        <p>
          Otro compromiso cancelado de Comunicaciones y Transportes fue el
          número 29: "Tramo corto de la red ferroviaria
          Aguascalientes-Guadalajara (primera etapa)". La obra se canceló debido
          a que, antes de llevarla a cabo, era necesario resolver dos juicios
          administrativos, uno de nulidad y uno de amparo, que al seguir en
          proceso impedían iniciar la licitación.
        </p>
        <p>
          En el Plan Nacional de Infraestructura se dijo que como beneficios
          este proyecto tendría "una longitud de 188.1 km, haciéndolo parte
          fundamental en la movilización de carga entre el Golfo y el Pacífico y
          hacia Estados Unidos, generando costos y tiempos de traslado más
          competitivos".
        </p>
        <p>
          <strong>Presa La Maroma</strong>
        </p>
        <p>
          En el caso de la Comisión Nacional del Agua (Conagua), se cancelaron
          tres compromisos. El número 52,  "Construir la Presa de Almacenamiento
          La Maroma en el Altiplano Potosino", se descartó debido a "la
          situación económica por la que atraviesa el país", según indicó el
          titular de la Comisión, Roberto Ramírez de la Parra.
        </p>
        <p>
          "No se asignaron recursos a este Compromiso de Gobierno, lo cual
          impidió obtener la autorización de la Secretaría de Hacienda y Crédito
          Público para iniciar la obra en el 2016 y ejecutarla plurianualmente",
          indicó Ramírez de la Parra.
        </p>
        <p>
          "Adicionalmente. la SCT en el 2017 no programó presupuesto para
          concluir los 5.0 km faltantes de los 14.0 km bajo su responsabilidad",
          agregó. "Por otro lado, la Conagua no cuenta con los estudios y el
          proyecto ejecutivo de los 3.0 km del tramo final del camino al sitio
          de la obra, camino indispensable para facilitar el tránsito de la
          maquinaria".
        </p>
        <p>
          En el proyecto de la obra, se indicó que podría tener como beneficios
          generación de empleos, detonar inversiones y por lo tanto mejorar el
          nivel de bienestar de la población en la zona.
        </p>
        <p>
          <strong>Presa en Sinaloa</strong>
        </p>
        <p>
          Otro compromiso que no podrán concretar la Conagua y Peña Nieto este
          sexenio es el número 98, la construcción de la Presa Santa María en
          Sinaloa, que tendría el objetivo de "apoyar las actividades
          agropecuarias".
        </p>
        <p>
          La Comisión explicó que originalmente se tenía previsto iniciar la
          obra el 26 de diciembre de 2014, y concluirla el 9 de enero de 2018,
          sin embargo "la falta de licencia de construcción emitida por el
          Municipio de Rosario, Sinaloa", hizo que el inicio de los trabajos
          fuera diferido hasta el 15 de junio de 2015.
        </p>
        <p>
          "Lo anterior representó un atraso significativo para la consecución
          del compromiso", según la instancia federal.
        </p>
        <p>
          Otros motivos que señaló la Comisión son "problemas técnicos como las
          condiciones geológicas desfavorables que se han encontrado en los
          túneles de desvío", además de{" "}
          <strong>
            "problemas sociales como los bloqueos al sitio de la obra por parte
            de habitantes de la localidad de Matatán
          </strong>{" "}
          y comuneros del poblado Santa María, por falta de pago de
          indemnizaciones e incumplimiento de compromisos del Gobierno del
          estado".
        </p>
        <p>
          Además de los factores mencionados, la Comisión reconoció que{" "}
          <strong>"constantes problemas de inseguridad"</strong> retrasaron aún
          más la obra, impidiendo que pudiera ser concluida este sexenio.
        </p>
        <p>
          En el proyecto de la obra, se dijo que podría beneficiar a 176 mil
          habitantes, en cuanto a consumo de uso público/urbano, y a 2 mil 833
          agricultores y sus familias. En cuanto a generación de energía
          eléctrica, se dijo que tenía como potenciales beneficiarios a 80 mil
          600 habitantes.
        </p>
        <p>
          <strong>Laguna de almacenamiento</strong>
        </p>
        <p>
          Conagua también informó sobre la cancelación del compromiso 136,
          "Concluir la laguna de almacenamiento de agua 'El Salto', en el
          municipio de Amecameca", Estado de México, en este caso, argumentando
          que "la problemática social" en la zona llevaron a que la obra fuera
          suspendidas desde abril de 2016.
        </p>
        <p>
          De acuerdo con un{" "}
          <a
            target="_blank"
            href="http://www.milenio.com/estados/impiden-amecameca-obra-tanque-almacenamiento-agua"
          >
            reporte del diario <em>Milenio</em>
          </a>, de abril de 2016, pobladores de la zona protestaron por la falta
          de información sobre el proyecto, y reclamaron que la obra podía
          despojarlos del agua proveniente del deshielo del volcán Iztaccíhuatl,
          siendo que el municipio tiene desabasto del líquido.
        </p>
        <p>
          Peña Nieto, en julio de 2013, dijo que la laguna de almacenamiento,
          con una inversión de 160 millones de pesos, permitiría "el
          aprovechamiento de aguas pluviales y el abastecimiento de agua potable
          a través de la captación de los escurrimientos generados por el
          deshielo de los volcanes, para emplearla en temporada de estiaje".
        </p>
        <p>
          <strong>Puerto Interior Tlaxcala</strong>
        </p>
        <p>
          La Secretaría de Economía explicó el motivo de la cancelación del
          compromiso 248, "Equipar con infraestructura básica el centro
          logístico e industrial 'Puerto Interior Tlaxcala', para que más
          empresas puedan instalarse en la entidad".
        </p>
        <p>
          En este caso, la administración de Peña Nieto responsabilizó al
          gobierno de Tlaxcala por no brindar las condiciones necesarias y no
          elaborar hasta abril de 2017 el proyecto ejecutivo de la obra, pese a
          que ya se había asignado un presupuesto de 60 millones de pesos, y se
          solicitó tal proyecto desde 2013.
        </p>
        <p>
          Además, la obra requería la expropiación de tres ejidos, La Magdalena
          Soltepec, San Lorenzo Soltepec, y José María Morelos Buenavista. Se
          realizó el procedimiento, pero ejidatarios se inconformaron e
          interpusieron juicios de amparo.
        </p>
        <p>
          <strong>Proyecto con refinería en Hidalgo</strong>
        </p>
        <p>
          Pemex, en cuanto a la cancelación del compromiso 83, "Aprovechamiento
          de residuales en la refinería Miguel Hidalgo", en el estado de
          Hidalgo, indicó que se debió a problemas financieros, ante la caída de
          los precios del petróleo.
        </p>
        <p>
           <strong>Centro de convenciones de Córdoba</strong>
        </p>
        <p>
           Por último, la Secretaría de Turismo informó que la cancelación del
          compromiso 61, "Construir el centro de convenciones de Córdoba,
          Veracruz", se debió a dos situaciones: un estudio de Fonatur
          identificó que no tenía las condiciones necesarias para que el
          proyecto fuera rentable, y en segundo lugar, el gobierno de Veracruz
          no cumplió a tiempo con la aportación de un terreno, para la
          construcción.
        </p>
        <p>
           En el Programa Nacional de Infraestructura, sobre este centro, se
          indicó que sería útil para la celebración "de grandes convenciones o
          exposiciones", que atrajeran a los turistas, en combinación con los
          atractivos naturales y culturales existentes. Peña Nieto destacó que
          la obra sería un generador de empleos, pero a fin de cuentas el
          proyecto fue incluido en la lista de sus promesas canceladas.
        </p>
      </div>
    )
  }
  /*
  {
    title:
      "Las obras de infraestructura que prometió Peña Nieto, en opacidad y con retrasos",
    sumario: "",
    author: "Nayeli Roldán y Manu Ureste",
    slug: "obras-infraestructura-retrasos",
    fecha: "8 de agosto, 2018",
    photo: {
      uri: require("../img/obras.jpg"),
      simplecredit: true,
      author: {
        name: "Universidad Autónoma de Yucatán",
        url: "https://twitter.com/santiago_arau"
      }
    },
    content: (
      <div>
        <p>
          Revisar cómo se realizaron las obras de infraestructura que prometió
          el presidente Enrique Peña Nieto para este sexenio es casi imposible
          para cualquier ciudadano. Con las fuentes de información pública
          disponibles no se puede dar seguimiento a los recursos asignados y
          ejecutados para cada proyecto, tampoco es posible conocer las razones
          para retrasar entregas o para gastar más de lo inicialmente
          proyectado.
        </p>
        <p>
          Como candidato, Enrique Peña Nieto firmó ante notario 266 compromisos
          y dijo que cumpliría cada uno ya en la Presidencia. De éstos, 106 —o
          el 39.8%— corresponden a infraestructura y fueron asignados a la
          Secretaría de Comunicaciones y Transportes (SCT). Hasta julio de 2018,
          se habían concluido 81 obras, 20 seguían en proceso, dos se reportaron
          como canceladas y una más había sido suspendida, según información
          proporcionada por la Presidencia de la República.
        </p>
        <p>
          <em>Animal Político</em> revisó información pública sobre el gasto
          proyectado y el ejecutado de cada obra, para comprobar el costo final.
          También se consultaron los tiempos reportados como previstos para
          concluir, las fechas oficiales de inauguración, las observaciones de
          la Auditoría Superior de la Federación (ASF) y las empresas
          contratadas. Sin embargo, los datos disponibles hacen imposible
          revisar cómo se ejecutaron los compromisos.
        </p>
        <p> </p>
        <p>
          Por ejemplo, no fue posible comparar montos presupuestados contra
          gastados porque las cifras no coinciden entre las fuentes de
          información disponibles: el Presupuesto de Egresos de la Federación de
          la Secretaría de Hacienda, los reportes de la Cuenta Pública, los
          informes de la Secretaría de Comunicaciones y Transportes y el Plan
          Nacional de Infraestructura 2014-2018. Los datos de cada uno de los
          compromisos tampoco se encuentran en un misma fuente de información.
        </p>
        <p>
          La Secretaría de Comunicaciones y Transportes, a cargo de Gerardo Ruiz
          Esparza, registra en el portal<a
            target="_blank"
            href="http://aga.sct.gob.mx/"
          >
            http://aga.sct.gob.mx/
          </a>{" "}
          el estatus de la obra pública, aunque no están disponibles todos los
          compromisos y en el caso de los que sí están, sus datos no coinciden
          con el portal de datos abiertos de la Presidencia.<a
            target="_blank"
            href="https://datos.gob.mx/"
          >
            https://datos.gob.mx/
          </a>
        </p>
        <p>
          Esta opacidad significa la posibilidad de “manipular la información de
          acuerdo al momento político. Si conviene o no decir que van por encima
          del costo, de los tiempos”. Y esto, finalmente es un riesgo de
          corrupción, advierte Max Kaiser, director de Anticorrupción del
          Instituto Mexicano para la Competitividad (IMCO).
        </p>
        <p>
          De hecho, el IMCO presentará este 4 de septiembre un análisis sobre el
          proceso de construcción del Nuevo Aeropuerto, una de las promesas de
          Peña Nieto, en el que darán a conocer que durante su investigación
          comprobaron la dificultad de revisar y dar seguimiento a los recursos
          y progreso de la obra con las herramientas de consulta públicas.
        </p>
        <p>
          “Nadie puede verificarlo. Tienes que saber de finanzas, tienes que
          tener conocidos en Hacienda, en la Función Pública para poder
          acercarte a la información completa y tú armar el rompecabezas. Hay
          que ser casi auditor”, sentencia Kaiser. Para el análisis del
          aeropuerto tuvieron que hacer cientos de solicitudes de información
          porque los datos disponibles en los portales de acceso público son
          insuficientes.
        </p>
        <p>
          <em>Animal Político</em> solicitó a la Secretaría de Comunicaciones y
          Transportes una explicación respecto a la diferencia en las cifras o
          las razones de los atrasos debido a que es una constante, pero sólo
          explicó los casos que se enviaron como ejemplo, de los cuales dos se
          mencionan más adelante.
        </p>
        <p>
          <strong>Sobrecosto sin explicación</strong>
        </p>
        <p>
          El Sistema del Tren Eléctrico Urbano en la zona Metropolitana de
          Guadalajara fue el compromiso del presidente número 4 en materia de
          infraestructura. El monto de inversión estaba previsto en 17 mil 693
          millones de pesos, pero según reportes de la cuenta pública terminó
          costando 24 mil 417 millones de pesos, lo que significaría un
          sobrecosto de 138%.
        </p>
        <p>
          El costo final también está referido en el informe “Acciones
          relevantes 2013-2017” publicado por la Secretaría de Comunicaciones
          rumbo al sexto informe de gobierno. Sin embargo, en el portal de datos
          abiertos de Obra pública e infraestructura, la dependencia reporta una
          inversión total de 25 mil 586 millones de pesos, con corte hasta el 30
          de abril de 2018. Es decir, hay una diferencia de mil 169 millones de
          pesos.
        </p>
        <p>
          En tanto, en el presupuesto de egresos de 2017, se contemplaba como
          costo total de la obra 22 mil 087 millones de pesos.
        </p>
        <p>
          Aunque en sí mismo el aumento en el presupuesto a una obra no
          significa corrupción, porque podría tener justificación en el aumento
          en el precio del dólar, de los materiales o algún contratiempo, en
          ningún reporte de la dependencia se encuentra la explicación del
          sobrecosto del tren y tampoco precisión sobre las cifras.
        </p>
        <p>
          Sobre esta obra, la Auditoría Superior de la Federación hizo dos
          revisiones. En la primera, de 2015, determinó irregularidades en la
          revisión de los requisitos de las empresas y determinó una
          recuperación de 3 millones de pesos.<a
            target="_blank"
            href="https://www.asf.gob.mx/Trans/Informes/IR2014i/Documentos/Auditorias/2014_0402_a.pdf"
          >
            https://www.asf.gob.mx/Trans/Informes/IR2014i/Documentos/Auditorias/2014_0402_a.pdf
          </a>{" "}
           En la de 2016 determinó un daño al erario por 26 millones de pesos
          por pagos duplicados y errores en los precios unitarios de los
          materiales.
        </p>
        <p>
          La obra inició en agosto de 2014 y aunque tiene 92% de avance, según
          el informe de la Secretaría de Comunicaciones, se prevé concluir este
          año y las pruebas operativas se iniciarían en el primer semestre,
          aunque no existe información respecto a que efectivamente ya se hayan
          realizado.
        </p>
        <p>
          Además, en la revisión se identificó que 31 obras de las prometidas
          por Peña Nieto tuvieron retraso en su ejecución. Es decir, se inauguró
          en una fecha posterior a la prevista. El caso con mayor retraso es la
          promesa 116, referente a “modernizar el transporte público urbano en
          la Región Lagunera, primera etapa”, se inició en 2015 y estaba
          proyectada para concluirse un año después, pero de acuerdo al reporte
          de la SCT, hasta julio de 2018, la obra tenía 11% de avance y no hay
          fecha de conclusión ni inauguración.
        </p>
        <p>
          <strong>Las cifras no cuadran</strong>
        </p>
        <p>
          El compromiso 22 se refiere a la construcción de la carretera
          Cardel-Poza Rica, primera etapa, en Veracruz, que inició en agosto de
          2014 y según el Plan Nacional de Infraestructura, se preveía un
          presupuesto de 4 mil 68 millones de pesos.
        </p>
        <p>
          Hasta abril de 2018, el gobierno federal informó que el costo total
          era de 3 mil 470 millones de pesos; la SCT decía que la inversión era
          de mil 730 millones de pesos, mientras que en la Cuenta Pública de
          2017, se contemplaban 5 mil 709 millones de pesos como costo total,
          aunque el presupuesto devengado y presupuestado está en ceros. Además,
          aunque la obra se inició en 2014, el gasto no está registrado en la
          Cuenta Pública de ese año, ni de 2015 y 2016.
        </p>
        <p>
          De acuerdo con la respuesta de la SCT, el costo de construcción se ha
          incrementado por obras adicionales de carácter social (pasos
          vehiculares y de ganado), por obras hidráulicas adicionales, obras
          inducidas para protección y reubicación de líneas de CFE y ductos de
          PEMEX y a trabajos generales como reubicación de plazas de cobro para
          hacer más eficiente la operación del corredor Cardel – Tihuatlán,
          equipamiento y fibra óptica. Además, “la inversión de esta obra
          corresponde a recursos privados por lo cual no se reporta en cuenta
          pública”, pero nada de esto es de consulta pública en el reporte de
          datos abiertos.
        </p>
        <p>
          El compromiso 187 “ampliación de la carretera San
          Buenaventura-Estación Hermanas” en Coahuila se inauguró en 2015, pero
          los datos en cada fuente son distintos. En el portal de transparencia
          presupuestaria de la Secretaría de Hacienda se registra un gasto total
          de 107 millones de pesos, mientras que en el presupuesto está
          calculado como gasto total 155 millones de pesos y en el Informe de
          Cuenta Pública se reportó el gasto de 437 millones de pesos.
        </p>
        <p>
          En tanto, la Modernización del Anillo Periférico Ecológico y
          construcción de la Ciclopista en Puebla se registra una inversión
          total de mil 253 millones de pesos en el portal del gobierno Federal,
          pero la SCT informa un costo de mil 355 millones de pesos y en el
          reporte de avance financiero a 2018 se reporta un gasto ejecutado de
          mil 466 millones de pesos y como costo total 2 mil 273 millones de
          pesos.
        </p>
        <p>
          De acuerdo con la respuesta de la SCT, estos cambios se deben a que la
          dependencia decidió construir seis y no cinco entronques como estaba
          previsto en la promesa original, lo que significó 101 millones de
          pesos. Además, el monto de inversión programado ante la SHCP de 2 mil
          273 millones de pesos “contempló inversión privada para trabajos a
          realizar por el Gobierno del Estado. Sin embargo, los trabajos se
          realizaron únicamente con recursos federales los cuales fueron
          reportados (1,466 mdp a precios constantes 2018)”.
        </p>
        <p>
          Max Kaiser, integrante del IMCO, advierte que una manera de combatir
          esta opacidad es tener un portal único de contrataciones públicas en
          el país en el que se registre el presupuesto y avance del proyecto
          prácticamente en tiempo real, para que cualquier ciudadano pueda dar
          seguimiento a una obra pública.
        </p>
        <p>
          La idea sería tener en un mismo sitio “cómo se planeó una obra, cómo
          se presupuesto, y la posibilidad de ir siguiendo cómo se va gastando”
          y técnicamente es posible. Esto, dice, debería ser tomado en cuenta
          por la próxima administración porque si el futuro presidente quisiera
          saber esta información tendría que preguntarle al menos a dos
          secretarios de Estado porque la información “es un desastre”, afirma.
        </p>
      </div>
    )
  },
  {
    title:
      "Veinte compromisos de infraestructura de Peña Nieto sumaron señalamientos de la ASF por irregularidades",
    sumario:
      "A lo largo de este sexenio, la Auditoría Superior de la Federación (ASF) detectó irregularidades millonarias en varias de las grandes obras prometidas por el presidente Peña Nieto.",
    author: "Manu Ureste y Nayeli Roldán",
    slug: "compromisos-infraestructura-irregularidades",
    fecha: "8 de agosto, 2018",
    photo: {
      uri: require("../img/infraestructura.jpg"),
      simplecredit: true,
      author: {
        name: "Universidad Autónoma de Yucatán",
        url: "https://twitter.com/santiago_arau"
      }
    },
    content: (
      <div>
        <p>
          De las <strong>(CUANTAS)</strong> promesas que hizo el presidente
          Enrique Peña Nieto en materia de infraestructura pública, la Auditoría
          Superior de la Federación (ASF) detectó, al menos (<strong>
            CUANTAS
          </strong>) irregularidades, que van desde pagos improcedentes a
          contratistas, obras de mala calidad, retrasos en la entrega, y{" "}
          <strong>(¿ALGUNA CIFRA APROXIMADA, RANGO?) </strong>miles de millones
          de dinero público que falta por aclarar en qué se gastaron.
        </p>
        <p>
          En total, Peña Nieto hizo 106 promesas de obra pública que
          correspondió atender a la Secretaría de Comunicaciones y Transportes
          (SCT). La ASF no auditó todas, solo una muestra de 20 que analizó{" "}
          <em>Animal Político</em>. De esas 20, tres destacan por la magnitud
          del proyecto y por la cantidad de irregularidades señaladas: el nuevo
          aeropuerto de la Ciudad de México, el tren México-Toluca, y el segundo
          piso de Puebla.{" "}
          <strong>
            (Y LAS OTRAS 17? NO PRESENTARON IRREGULARIDADES? HABRIA QUE
            MENCIONAR ESTE DATO AQUÍ… YA VI QUE EN LA PARTE FINAL DEL TEXTO ESTA
            ESTE DATO, PERO VALE LA PENA SUBIRLO. LA PARTE DE ABAJO SE QUEDA
            IGUAL)
          </strong>
        </p>
        <p>
          <strong>
            Nuevo aeropuerto, señalamientos por más de mil millones
          </strong>
        </p>
        <p>
          La obra de infraestructura más importante no solo del sexenio, sino de
          los últimos 60 años en México. Así presentó el presidente Peña Nieto
          su promesa del Nuevo Aeropuerto Internacional de la Ciudad de México
          (NAICM).
        </p>
        <p>
          Sin embargo, el proyecto estrella del gobierno peñista es también una
          de las obras públicas del sexenio con más señalamientos de la ASF.
        </p>
        <p> </p>
        <p>
          Tan solo en el informe de la Cuenta Pública 2016, la Auditoría
          Superior de la Federación hizo siete auditorías a Grupo Aeropuertario
          de la Ciudad de México, la empresa de participación estatal
          responsable de la construcción del NAICM, en la que realizó
          observaciones por mil millones de pesos.
        </p>
        <p>
          Entre las observaciones, la ASF detectó pagos en exceso a
          contratistas, gastos innecesarios en comunicación social, servicios
          que no se comprobaron con documentación, la formalización de convenios
          fuera de tiempo, o pagos por materiales de obra a precios fuera de
          mercado.
        </p>
        <p>
          Un año antes, en la Cuenta Pública 2015, la ASF también hizo 25
          observaciones a la construcción del nuevo aeropuerto<a
            target="_blank"
            href="https://www.animalpolitico.com/2017/03/irregularidades-835-mdp-nuevo-aeropuerto-asf/"
          >
            por 835 millones de pesos
          </a>, de los que 181 millones corresponden a gastos irregulares, y los
          otros 653 millones deben ser aclarados por el GAICM. Ese año, la ASF
          señaló pagos duplicados a empresas, servicios que no fueron
          ejecutados, anticipos indebidos a contratistas y falta de comprobación
          de recursos.
        </p>
        <p> </p>
        <p>
          Según consta{" "}
          <a target="_blank" href="http://www.asfdatos.gob.mx/">
            en el portal de datos de la ASF
          </a>, de las 42 observaciones que la Auditoría realizó al GAICM en la
          Cuenta Pública 2016, aún quedan 12 por resolver por un monto de 611
          millones de pesos. El resto, fueron atendidas por el GAICM. Mientras
          que en la Cuenta Pública 2015, el Grupo Aeropuertario aclaró con la
          entrega de documentación el gasto de 653 millones de pesos, restándole
          por solventar aún otras ocho observaciones por irregularidades que
          suman 145 millones de pesos.
        </p>
        <p> </p>
        <p>
          <a
            target="_blank"
            href="https://www.animalpolitico.com/2018/02/aeropuerto-naicm-irregularidades-auditoria/"
          >
            Tras la publicación en febrero
          </a>{" "}
          de este año de una nota sobre los señalamientos de la ASF, el Grupo
          Aeropuertario de la Ciudad de México argumentó por medio<a
            target="_blank"
            href="https://es.scribd.com/document/387281490/Respuesta-GAICM"
          >
            de una respuesta escrita a <em>Animal Político</em>
          </a>{" "}
          que las irregularidades se refieren, en su mayoría, a “solicitudes de
          aclaración” del gasto que irán solventando progresivamente. Por lo que
          subrayó que “no hay ningún daño patrimonial, ni actos de corrupción”
          en esta obra.
        </p>
        <p>
          Además de los informes de la ASF, otro punto polémico es el sobrecosto
          del nuevo aeropuerto: en 2014, cuando se presentó el proyecto, se dijo
          que la inversión sería de 169 mil millones de pesos. En agosto de este
          año, el costo previsto ya es de 285 mil millones de pesos, hasta un
          68% más.
        </p>
        <p>
          Gerardo Ruiz Esparza, titular de la Secretaría de Comunicaciones y
          Transportes (SCT), argumentó<a
            target="_blank"
            href="https://twitter.com/gruizesp/status/1032305909563678720?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1032305909563678720&amp;ref_url=https%3A%2F%2Fexpansion.mx%2Fnacional%2F2018%2F08%2F22%2Fruiz-esparza-justifica-el-alza-en-el-costo-del-nuevo-"
          >
            en su cuenta de Twitter
          </a>{" "}
          que “el costo original” siempre ha sido de 13 mil 300 millones de
          dólares. Pero el aumento del precio de los materiales de construcción
          y, sobre todo, la progresiva depreciación del peso, es lo que ha
          provocado que esos 13 mil 300 millones de dólares de 2014 cuesten,
          cuatro años después, 285 mil millones de pesos.
        </p>
        <p>
          Está previsto que la primera fase del NAICM esté lista en el 2020,
          aunque actualmente la continuación del proyecto está en duda, pues
          Andrés Manuel López Obrador, actual presidente electo,<a
            target="_blank"
            href="https://www.animalpolitico.com/2018/08/el-futuro-del-nuevo-aeropuerto-de-mexico-se-decidira-por-consulta-en-octubre-amlo/"
          >
            propuso una consulta ciudadana en octubre
          </a>{" "}
          para decidir el futuro de la obra, luego de que durante su campaña
          prometiera cancelarlo por considerarlo excesivamente caro.
        </p>
        <p>
          <strong>
            Tren México-Toluca: retraso, sobrecostos, e irregularidades
          </strong>
        </p>
        <p>
          La construcción del tren interurbano México-Toluca es otro de los
          compromisos de Peña Nieto que no se cumplirá a tiempo, registra
          sobrecosto, y cuenta con una amplia lista de señalamientos.
        </p>
        <p>
          En la Cuenta Pública 2016, en el informe de inversiones físicas
          335-DE, la ASF hizo observaciones a la SCT por un total de 2 mil 751
          millones de pesos, de los cuales mil 775 millones corresponden a pagos
          indebidos en la obra, y mil 102 millones al gasto de recursos públicos
          que deben ser aclarados.
        </p>
        <p>
          Entre los pagos indebidos, la ASF detectó que la SCT pagó 117 millones
          de pesos a una empresa para realizar una serie de modificaciones al
          proyecto del tren, a pesar de que esa misma empresa fue quien realizó
          el proyecto originalmente. Además, se pagaron 51 millones de pesos por
          materiales de construcción fuera de catálogo, y otros 38 millones a
          otra empresa para que diera asesoría, control y seguimiento al
          proyecto ferroviario, cuando era el gobierno de la Ciudad de México el
          encargado de asumir estas tareas.
        </p>
        <p>
          En la Cuenta Pública 2015, la ASF también determinó que la SCT hizo
          pagos indebidos por 137 millones de pesos en esta obra. De este monto,
          99 millones 103 mil pesos corresponden a pagos de servicios en obras
          que se encontraban suspendidas o que aún no había iniciado; y 30
          millones 147 mil pesos por el incumplimiento de las especificaciones
          de construcción.{" "}
          <strong>
            (CHECARON EN LA PAGINA DE DATOS DE LA ASF E ESTATUS DE LA
            AUDITORIA?)
          </strong>
        </p>
        <p>
          El Instituto Mexicano para la Competitividad (IMCO) realizó otro
          informe<a
            target="_blank"
            href="https://imco.org.mx/temas/ineficiencia-riesgos-corrupcion-obra-publica-caso-estudio-del-tren-interurbano-mexico-toluca/"
          >
            (que puedes checar aquí)
          </a>, en el que denuncia que la construcción del tren ha tenido un
          proceso de contratación “desorganizado y opaco”, por lo que detectaron
          “riesgos de corrupción” en la construcción.
        </p>
        <p>
          El proyecto del tren México-Toluca también presenta sobrecosto. De
          acuerdo con el<a
            target="_blank"
            href="https://es.scribd.com/document/387281684/Programa-Nacional-de-Infraestructura-2014-2018"
          >
            Programa Nacional de Infraestructura 2014-2018
          </a>, la inversión total prevista era de 38 mil 608 millones de pesos.
          Sin embargo, según consta en el Presupuesto de Egresos de 2018, el
          costo total ya va por los 59 mil 216 millones de pesos; un 62% más.
        </p>
        <p>
          Ruiz Esparza argumentó, en declaraciones que recoge el diario<a
            target="_blank"
            href="http://www.jornada.com.mx/ultimas/2018/06/14/tren-mexico-toluca-dentro-de-201cun-costo-razonable201d-sct-1686.html"
          >
            La Jornada
          </a>{" "}
          el pasado 14 de junio, que la depreciación del peso frente al dólar,
          así como la inflación y el cambio de trazo del proyecto, originaron el
          sobrecosto.
        </p>
        <p>
          En cuanto al periodo de entrega, el Programa Nacional de
          Infraestructura prometía que la obra estaría terminada en diciembre de
          2017. Pero, a poco más de cuatro meses para que termine 2018, la
          construcción no finaliza, aunque la SCT prometió terminarla este mismo
          año, para que el tren pueda empezar a operar entre mayo y junio del
          próximo 2019.
        </p>
        <p>
          <strong>
            El segundo piso de Puebla: una promesa costosa e irregular
          </strong>
        </p>
        <p>
          Otra de las grandes promesas de Peña Nieto es la construcción del
          segundo piso de Puebla; una obra que el presidente presumió como la
          responsable de acortar a 10 minutos un recorrido que antes tomaba una
          hora.
        </p>
        <p>
          Tal y como documentó una investigación de <em>Animal Político</em>,<a
            target="_blank"
            href="https://www.animalpolitico.com/segundo-piso-puebla-promesa-costosa-irregular-pena-y-moreno-valle/"
          >
            que puedes leer aquí
          </a>, la promesa de campaña se cumplió, aunque para hacerlo, se
          seleccionó la opción más cara para el Estado y se realizó sin un
          estudio previo que justificara la inversión de 4 mil 500 millones de
          pesos del erario.
        </p>
        <p>
          Además, la obra se adjudicó de manera directa, sin licitación o
          concurso público, a la empresa española OHL, siendo esta compañía, y
          no el Estado, la que tendrá la concesión de las cuotas que miles de
          automovilistas deberán pagar si quieren utilizar el segundo piso,
          durante los próximos 30 años.
        </p>
        <p>
          Por su parte, la ASF revisó el desarrollo de la obra entre 2014 y
          2016, y detectó costos inflados en la ejecución de la misma por más de
          mil 173 millones de pesos. También detectó pagos por obras y servicios
          no realizados por más de 180 millones de pesos, y un pago de 155
          millones 689 mil pesos en 24 conceptos sin contar con la documentación
          que acredite dicho pago.
        </p>
        <p>
          Otra de las irregularidades expuestas por la ASF, es que se otorgó a
          OHL un monto de 2 mil 762 millones de pesos por concepto de anticipo,
          “sin que éste estuviera establecido en el título de concesión” de la
          obra.
        </p>
        <p> </p>
        <p>Según la web de datos de la ASF,  </p>
        <p>
          <br />
          <br />
        </p>
        <p>
          (<strong>CHECAR EN PAGINA DE DATOS DE LA ASF EL ESTATUS).</strong>
        </p>
        <p>
          Incluso, la ASF señala que se realizaron “trabajos de mala calidad” en
          la construcción millonaria; especialmente, en la instalación de
          trabes, cabezales y en los ramales de tuberías de PVC.
        </p>
        <p>
          En cuanto al costo, estaba previsto que fuera de 10 mil millones de
          pesos, de los que el Gobierno Federal aportaría 5 mil millones, y el
          resto lo pondría la empresa concesionaria. Sin embargo, la obra costó
          10 mil 500 millones -500 más de lo programado-, y aunque el Gobierno
          Federal dijo que había inyectado 5 mil millones, la Secretaría de
          Hacienda informó a <em>Animal Político</em> que finalmente fueron 4
          mil 500 millones; situación por la que la ASF ordenó al órgano interno
          de control de la SCT el inicio de una promoción de responsabilidad
          sancionatoria contra sus funcionarios.
        </p>
        <p>
          <strong>Otras promesas con señalamientos</strong>
        </p>
        <p>
          Al margen de estas obras, otras 17 promesas de Peña Nieto en materia
          de infraestructura recibieron diferentes tipos de señalamientos de la
          ASF.
        </p>
        <p>
          Por ejemplo, en la construcción del libramiento ferroviario de Celaya,
          en Guanajuato, la ASF halló en la revisión de la Cuenta Pública 2014
          que la SCT pagó 73 millones 898 mil pesos por material de construcción
          “sin el soporte documental de rendimientos y costos”.
        </p>
        <p>
          En Colima, Peña Nieto prometió construir la carretera Pez Vela-Jalipa.
          El proyecto sí concluyó, aunque lo hizo con más de un año de retraso.
          Mientras que la ASF, en la Cuenta Pública 2014, hizo observaciones por
          66 millones 711 mil pesos debido “obra pagada que no se ejecutó
          oportunamente”. Además, detectó “trabajos de mala calidad” por 3
          millones 875 mil pesos.
        </p>
        <p>
          En Querétaro, Peña Nieto también cumplió con la ampliación del Paseo
          de la República. Pero la ASF detectó “pagos improcedentes” por 46
          millones de pesos “por obra pagada que no se ejecutó”.
        </p>
        <p>
          Y en Coahuila, en la modernización de la carretera San Pedro-Cuatro
          Ciénagas, la ASF señaló sobrecostos por 32 millones de pesos.
        </p>
        <p>
          Utiliza el gratuito{" "}
          <a target="_blank" href="https://html-cleaner.com/js/">
            programa de formateador JavaScript
          </a>{" "}
          para dar formato a las secuencias de comandos del cliente para
          optimizar tu código.
        </p>
      </div>
    )
  },

  {
    title:
      "En Salud, rubro en el que Peña Nieto acumula más compromisos pendientes ",
    sumario:
      "El presidente todavía tiene por cumplir 13 de sus 27 promesas vinculadas a la Secretaría de Salud. Según datos oficiales, algunas de éstas no tienen avance ni de 40%, pese a que su gestión le quedan tres meses.",
    author: "Tania Montalvo (@tanlmont)",
    slug: "salud-mas-compromisos-pendientes",
    fecha: "8 de agosto, 2018",
    photo: {
      uri: require("../img/salud.jpg"),
      simplecredit: true,
      author: {
        name: "Universidad Autónoma de Yucatán",
        url: "https://twitter.com/santiago_arau"
      }
    },
    content: (
      <div>
        <p>
          La construcción, remodelación y ampliación de hospitales fue una de
          las promesas que Enrique Peña Nieto más repitió y firmó ante notario
          como candidato a la Presidencia. Seis años después, al cierre de su
          gestión, el 44% de esos compromisos no se han concretado y los que ya
          cumplió, fueron obras con retraso y que superaron el presupuesto
          asignado originalmente.
        </p>
        <p>
          Peña Nieto firmó en total 266 compromisos, mismos que se convirtieron
          en las principales promesas de su administración. A la Secretaría de
          Salud se le asignaron el 10% de esos compromisos, la tercera instancia
          del gobierno federal con más por cumplir solo por detrás de la
          Secretaría de Comunicaciones y Transportes (SCT) y la Comisión
          Nacional del Agua (Conagua) que juntas suman 104 o la mitad de las
          promesas del presidente.
        </p>
        <p>
          Al finalizar agosto de 2018, el gobierno de Peña Nieto reporta que ya
          cumplió con 15 de los compromisos asignados a Salud y que 13 más están
          en proceso. Aunque según la información reportada por esa misma
          secretaría y Hacienda, entre los pendientes hay hospitales con cero
          avance o menos del 50%.
        </p>
        <p>
          Por ejemplo, según los reportes que la Secretaría de Hacienda entrega
          al Congreso, al segundo trimestre de 2018, el Hospital Materno
          Infantil de la ciudad de Tijuana no tiene avances registrados;
          mientras que el Plan Maestro de Infraestructura Física en Salud
          reportó en junio de este año que la obra se ha suspendido, aunque es
          un compromiso que se mantiene vigente según Presidencia de la
          República.
        </p>
        <p>
          Otras obras “en proceso” con retrasos son el Hospital de
          Especialidades de Chetumal, el compromiso 165 del listado de Peña
          Nieto. El Programa Nacional de Infraestructura señala que la entrega
          se preveía para 2016, pero a junio de este año el avance reportado de
          la obra es de apenas 21%.
        </p>
        <p>
          El Hospital General de Ciudad Madero, Tamaulipas también registra una
          avance menor: 35% al segundo trimestre de 2018.
        </p>
        <p>
          Apenas el pasado 17 de agosto, el presidente dijo que cumpliría con
          los compromisos que firmó como candidato en cada estado de la
          República. Ese día, Peña Nieto entregó el Hospital General de
          Tapachula, su compromiso número 235.
        </p>
        <p>
          El mandatario destacó que en la recta final de su gestión como
          presidente dedicaría “buena parte de su tiempo” para seguir{" "}
          <a
            target="_blank"
            href="https://www.gob.mx/presidencia/prensa/palabras-del-presidente-de-los-estados-unidos-mexicanos-170772?idiom=es"
          >
            entregando obras y cumpliendo compromisos
          </a>. Lo que Peña Nieto no dijo es que, como ocurrió con otros
          Hospitales, algunas de las unidades médicas se inauguraron fuera del
          tiempo programado o costaron más de lo presupuestado originalmente.
        </p>
        <p>
          El mismo Hospital General de Tapachula que debió entregarse en 2016,
          según el Programa Nacional de Infraestructura, se inauguró dos años
          después, en la recta final del sexenio peñista. La inauguración fuera
          de tiempo también ocurrió con el Hospital General de Cancún, Quintana
          Roo que comenzó a operar con dos años de retraso o el Hospital General
          de Tampico.
        </p>
        <p>
          Unidades médicas que continúan en proceso y acumulan retraso, además
          de cambios presupuestales son las de los compromisos número 44 —el
          Centro Integral de Oncología del Estado de México cuyo costo original
          era de 300 millones de pesos para concluirse en 2016 y aún en obra, el
          presupuesto ya aumentó 25%— y la promesa 153 de la lista, el Hospital
          General de Michoacán que debía entregarse en 2015 y que tuvo un
          presupuesto en julio de ese año de 632 millones, pero para 2018 el
          costo aumentó a 880 millones de pesos.
        </p>
        <p>
          <a
            target="_blank"
            href="https://www.siglo.mx/coahuila/noticia/231360.hospital-oncologico-retrasa-apertura-por-falta-de-permisos.html"
          >
            <em>El Siglo de Coahuila </em>reportó
          </a>{" "}
          el pasado 23 de agosto que el Centro Oncológico Salvador Chavarría
          —compromiso 53 de Peña Nieto— no ha iniciado operaciones porque están
          en trámite los permisos, aunque el exgobernador del estado, Rubén
          Moreira, lo inauguró en noviembre de 2017.
        </p>
        <p>
          Otros hospitales que se reportan “en proceso” entre los compromisos de
          Peña Nieto son el Hospital Regional Materno Infantil de Coatzacoalcos,
          Veracruz; el Hospital General de Matamoros —que debió inaugurarse en
          marzo pasado, pero cuya apertura se suspendió por falta de equipo
          médico—; el Hospital de Especialidades de Juchitán que comenzó a
          construirse en agosto de 2017; o el Hospital geriátrico del Área
          Metropolitana de Guadalajara, cuyo avance se reportó de 85% al cierre
          del segundo trimestre de este año.
        </p>
      </div>
    )
  },
  {
    title:
      "Del 1DMX a la Ley Chayote: EPN ante el fracaso su “manifiesto democrático” del 2012",
    sumario:
      "Durante su campaña, el priista dijo que su gobierno garantizaría la libertad de expresión, de manifestación, el respeto a derechos humanos y otros 7 puntos. Sin embargo, falló desde el primer día de gobierno, señalan organizaciones.",
    author: "León Ramírez",
    slug: "ley-chayote-1dmx",
    fecha: "8 de agosto, 2018",
    photo: {
      uri: require("../img/manifiesto.jpg"),
      simplecredit: true,
      author: {
        name: "Universidad Autónoma de Yucatán",
        url: "https://twitter.com/santiago_arau"
      }
    },
    content: (
      <div>
        <p>
          Enrique Peña Nieto presentó ante empresarios, activistas e
          intelectuales el manifiesto “Por una Presidencia Democrática”. El
          hecho ocurrió el 21 de mayo del 2012 y se convirtió en el compromiso
          265 de los 266 que firmó ante notario público durante su campaña
          presidencial.
        </p>
        <p> </p>
        <p>
          En aquél momento, el candidato priista dijo que de ganar las
          elecciones seguiría los{" "}
          <a
            target="_blank"
            href="https://www.animalpolitico.com/2012/05/pena-nieto-presenta-su-manifiesto-democratico-documento-integro/"
          >
            10 puntos que integran este texto
          </a>, pero a tres meses de que termine su mandato, el presidente falló
          en seis.
        </p>
        <p> </p>
        <p>
          <strong>1.Libertad de manifestación</strong>
        </p>
        <p> </p>
        <p>
          Durante su campaña hubo varias manifestaciones contra su candidatura,
          la más significativa fue la de estudiantes en la Universidad
          Iberoamericana que derivó en el movimiento #YoSoy132.
        </p>
        <p> </p>
        <p>
          10 días después de las protestas estudiantiles presentó el Manifiesto
          y dijo: “como presidente de la República protegeré el ejercicio de
          este derecho en todos los espacios públicos del territorio nacional”.
          Pero desde que asumió la presidencia  –el 1 de diciembre del 2012–
          sucedió lo contrario.
        </p>
        <p> </p>
        <p>
          Durante el llamado 1DMX, autoridades federales y del entonces Distrito
          Federal reprimieron a quienes se manifestaban en contra de Peña Nieto
          haciendo uso excesivo de la fuerza. Se realizaron más de cien
          detenciones, según el{" "}
          <a
            target="_blank"
            href="https://articulo19.org/wp-content/uploads/2018/03/INFORME-A19-2017_v04.pdf"
          >
            informe anual de Article 19{" "}
            <em>Democracia simulada, nada que aplaudir</em>
          </a>
          <em>.</em>
        </p>
        <p> </p>
        <p>
          El enfrentamiento entre maestros y autoridades en Nochixtlán, Oaxaca,
          es otro de los casos reportados por la organización, pues “se presentó
          una respuesta represiva letal” que contravino los principios de
          legalidad, estricta necesidad, proporcionalidad y precaución.
        </p>
        <p> </p>
        <p>
          “Peña Nieto falló completamente”, comenta en entrevista Leopoldo
          Maldonado, abogado de Article 19. “La verdadera postura que tuvo el
          gobierno federal, en consonancia con algunos gobiernos estatales, fue
          tratar de restringir el ejercicio de la manifestación”, añade.
        </p>
        <p> </p>
        <p>
          En este sexenio, continúa Maldonado, los legisladores federales y
          locales trataron de inhibir el ejercicio de derechos en espacios
          públicos, se buscó desacreditar a quienes se manifestaban, mientras
          que las policías locales y la federal hicieron uso indiscriminado de
          la fuerza.
        </p>
        <p> </p>
        <ol start="2">
          <li>
            <strong> Libertad de expresión</strong>
          </li>
        </ol>
        <p> </p>
        <p>
          <strong>
            “Seré garante de la libertad de expresión”, señaló Peña Nieto en el
            segundo punto de su manifiesto
          </strong>. Aseguró entonces que “en una presidencia democrática no
          caben ni la violencia en contra de periodistas, ni la censura”. Sin
          embargo, al 31 de diciembre del 2017, hubo mil 986 agresiones contra
          la prensa en el país y 45 comunicadores han sido asesinados en lo que
          va de su gobierno, según información de Article 19.
        </p>
        <p> </p>
        <p>
          A pesar de la existencia de una Fiscalía Especial para la Atención de
          Delitos cometidos contra la Libertad de Expresión (FEADLE) en 2010 y
          un Mecanismo de Protección para Personas Defensoras de Derechos
          Humanos y de Periodistas la violencia contra periodistas ha sido una
          constante en el actual gobierno en estados como Veracruz, Oaxaca y
          Ciudad de México.
        </p>
        <p> </p>
        <p>
          De acuerdo con Maldonado, “no se puede hablar de que hay garantías y
          protección a la libertad de prensa para este gobierno cuando los
          registros dan cuenta de todo lo contrario. Se ha fracasado en brindar
          garantías de seguridad para periodistas en el país”.
        </p>
        <p> </p>
        <p>
          <strong>3.Relación con medios de comunicación</strong>
        </p>
        <p> </p>
        <p>
          En su tercer punto,<strong>
            {" "}
            Peña Nieto afirmó que iba a impulsar una reforma constitucional para
            crear una “instancia ciudadana y autónoma que supervise la
            contratación de publicidad
          </strong>{" "}
          de todos los niveles de gobierno en medios de comunicación de todos
          los niveles de gobierno” que además responda a criterios de utilidad
          pública y transparencia.
        </p>
        <p> </p>
        <p>
          Si bien se aprobaron las reformas a los artículos constitucionales 41
          –normativa y uso de recursos en elecciones– y 134 –uso de recursos por
          parte de servidores públicos–, el gobierno federal no impulsó una
          regulación de la publicidad o la creación de una instancia ciudadana.
        </p>
        <p> </p>
        <p>
          Inclusive, la organización Fundar encontró que de 2013 a 2017 se
          gastaron 50 mil 862 millones de pesos en publicidad oficial en México,
          que es 23 mil millones más de lo que había aprobado inicialmente el
          Congreso. “Todo quedó en letra muerta”, señala Paulina Castaño,
          investigadora del Programa de Justicia Penal de Fundar.
        </p>
        <p> </p>
        <p>
          El 11 de mayo, Peña Nieto publicó la Ley General de Comunicación
          Social, que entrará en vigor a partir del 1 de enero del 2019. Según
          sus críticos, que la bautizaron como #LeyChayote, esta ley afecta a la
          libertad de expresión y el derecho a la información al generalizar
          prácticas discrecionales y permitir que la publicidad oficial se
          utilice como mecanismo de control a la prensa.
        </p>
        <p> </p>
        <p>
          “Pedíamos un proceso de parlamento abierto, un proceso participativo
          para la elaboración de esta ley. Finalmente no se cumplió [lo que
          afirmó Peña Nieto], ni el proceso ni esta ley”, lamenta Castaño.
        </p>
        <p> </p>
        <ol start="4">
          <li>
            <strong> Derechos Humanos</strong>
          </li>
        </ol>
        <p> </p>
        <p>
          Del 2013 al 2017 se registraron 119 mil 568 homicidios, según el
          Instituto Nacional de Estadística y Geografía (INEGI). El último año,
          incluso, alcanzó un récord histórico, con 31 mil 174 homicidios. La
          Comisión Nacional de Derechos Humanos (CNDH) emitió en el mismo
          periodo un total 368 recomendaciones por violaciones a derechos
          humanos a distintas instancias federales, según los informes anuales.
        </p>
        <p> </p>
        <p>
          <strong>
            Lo anterior se opone al apartado sobre derechos humanos del
            manifiesto, en el que Peña Nieto dijo que el gobierno tendría un rol
            “más activo en la promoción de derechos humanos”
          </strong>, que el respeto a estos “debe ser premisa fundamental para
          el uso de la fuerza pública”, y anunció que promovería las reformas
          necesarias para darle eficacia a la reforma constitucional en materia
          de derechos humanos del 2011.
        </p>
        <p> </p>
        <p>
          Casos como la desaparición de los 43 estudiantes de la normal de
          Ayotzinapa, las ejecuciones extrajudiciales en Tlatlaya y Nochixtlán
          exhiben también las violaciones a derechos humanos por parte del
          gobierno, explica la directora de Cencos, Ixhel Cisneros.
        </p>
        <p> </p>
        <p>
          Peña, diputados y senadores del PRI y del PAN, PVEM y Nueva Alianza
          aprobaron la Ley de Seguridad Interior, que va en contra de una
          estrategia de seguridad integral, que le da más herramientas a las
          fuerzas armadas y a la marina. Solo fue un parche, añadió.
        </p>
        <p> </p>
        <p>
          “Se quedó corta la promesa y creyeron que con la Ley de Seguridad
          Interior se iban a solucionar cosas pero con esta ley refuerzan la
          violencia que se ha visto”, explica Cisneros.
        </p>
        <p>
          <br />
          <br />
        </p>
        <ol start="5">
          <li>
            <strong> Libertad religiosa</strong>
          </li>
        </ol>
        <p> </p>
        <p>
          Sobre libertad religiosa, Peña Nieto dijo que encabezaría{" "}
          <strong>
            “un gobierno laico, respetuoso de la libertad de creencias y de las
            prácticas religiosas de todos los mexicanos”
          </strong>,un principio estipulado en la Constitución Mexicana.
        </p>
        <p> </p>
        <p>
          Durante su gobierno se reformó el artículo 24 constitucional, que
          otorga libertad no solo religiosa sino de convicciones éticas y
          conciencia, además de que establece que no se podrán utilizar actos
          públicos de este tipo con fines políticos, de proselitismo o de
          propaganda política. También, en una reforma al artículo 40, se agregó
          la definición de laico al país.
        </p>
        <p> </p>
        <p>
          <em>Pendiente quote</em>
        </p>
        <p>
          <br />
          <br />
        </p>
        <ol start="6">
          <li>
            <strong> No discriminación</strong>
          </li>
        </ol>
        <p> </p>
        <p>
          Peña propuso en otro punto del Manifiesto “utilizar el poder
          presidencial para acabar con la discriminación en México”, añadió que
          gobernaría sin perjuicio y que darían “un trato a los migrantes en
          México como el que exigimos para nuestros paisanos en el extranjero”.
        </p>
        <p> </p>
        <p>
          Sin embargo, el panorama sobre discriminación no es bueno. De acuerdo
          con la e<a
            target="_blank"
            href="http://www.beta.inegi.org.mx/proyectos/enchogares/especiales/enadis/2017/"
          >
            ncuesta Nacional sobre Discriminación (Enadis), el más reciente
            balance del Inegi y el Consejo Nacional para Prevenir la
            Discriminación (Conapred)
          </a>, una de cada cinco personas mayores de edad en México fueron
          discriminadas durante 2017, principalmente por motivos relacionados
          con su apariencia física, su arreglo personal, su edad o por profesar
          una religión distinta a la católica.
        </p>
        <p> </p>
        <p>
          Respecto al trato a migrantes, tras una reunión con el entonces
          presidente Barack Obama, Peña Nieto anunció el 7 de julio del 2014 la
          aplicación del{" "}
          <a
            target="_blank"
            href="https://pajaropolitico.com/caceria-de-migrantes/"
          >
            Programa Frontera Sur
          </a>, que oficialmente pretendía ayudar a los migrantes, pero que se
          basó en seguridad fronteriza y control migratorio.
        </p>
        <p> </p>
        <p>
          Un total de 10,319 migrantes registrados ante la Red de Documentación
          de las Organizaciones Defensoras de Migrantes (Redodem) dijo haber
          sufrido un delito en su paso por México del 2014 al 2017, según los
          informes anuales de la Redodem (<a
            target="_blank"
            href="https://www.entreculturas.org/sites/default/files/informe_redodem.pdf"
          >
            2015{" "}
          </a>,{" "}
          <a
            target="_blank"
            href="https://www.entreculturas.org/sites/default/files/noticias/informe_redodem.pdf"
          >
            2016
          </a>,{" "}
          <a
            target="_blank"
            href="https://drive.google.com/file/d/17ZfAF-IHAD-NphvIlB8lbHXWqVUA7dbG/view"
          >
            2017
          </a>).
        </p>
        <p> </p>
        <p>
          De un total de 5 mil 824 delitos contra migrantes cometidos entre 2014
          y 2016, en Chiapas, Oaxaca, Tabasco, Sonora, Coahuila y a nivel
          federal, sólo se encontró evidencia de 49 sentencias, por lo que la
          impunidad para este grupo fue de 99%, según el{" "}
          <a
            target="_blank"
            href="https://www.wola.org/wp-content/uploads/2017/07/Accesoalajusticia_Versionweb_Julio20172.pdf"
          >
            estudio{" "}
            <em>
              El acceso a la justicia para las personas migrantes en México: un
              derecho que existe sólo en el papel
            </em>
          </a>.
        </p>
        <p> </p>
        <p>
          <em>Quote pendiente</em>
        </p>
        <p> </p>
        <ol start="7">
          <li>
            <strong> División de poderes</strong>
          </li>
        </ol>
        <p> </p>
        <p>
          Desde que inició su cargo, el presidente emprendió el Pacto por
          México, en concordancia con{" "}
          <strong>el punto “División de poderes” del manifiesto</strong>, en el
          que se comprometió a “tener un diálogo permanente y abierto con los
          liderazgos de todas las fracciones parlamentarias para lograr la
          aprobación, con amplios consensos, de las grandes reformas que México
          necesita”.
        </p>
        <p> </p>
        <p>
          Esta alianza entre las distintas fuerzas políticas del país se alcanzó
          el 2 de diciembre y logró la aprobación de{" "}
          <a
            target="_blank"
            href="https://www.gob.mx/presidencia/articulos/cuales-son-las-reformas-impulsadas-por-el-presidente-enrique-pena-nieto"
          >
            11 reformas estructurales
          </a>{" "}
          (entre las que se encuentran la energética, educativa y hacendaria),
          aunque concluyó cuando el PRD salió de él en noviembre del 2013. Desde
          entonces no se alcanzó otro acuerdo de ese tipo.
        </p>
        <p> </p>
        <p>
          (PERO ENTONCES CUMPLIÓ O NO CUMPLIÓ O CUMPLIÓ A MEDIAS? O QUE PASO
          ALLI?; POR QUÉ NO SE CONSULTÓ O ENTREVISTÓ A ALGUIEN COMO EL RESTO DE
          LOS PUNTOS?)
        </p>
        <p> </p>
        <ol start="8">
          <li>
            <strong> Elecciones libres</strong>
          </li>
        </ol>
        <p> </p>
        <p>
          Peña Nieto expresó en otro punto que, como presidente de México, no
          intervendría en elecciones “salvo garantizar que existan siempre las
          condiciones de seguridad y paz para el desarrollo de campañas y
          jornadas electorales” y anunció que promovería iniciativas de reforma
          “para erradicar definitivamente el uso electoral de los programas
          sociales de los tres niveles de gobierno”.
        </p>
        <p> </p>
        <p>
          Peña Nieto no impulsó iniciativas para erradicar la compra y coacción
          de votos.
        </p>
        <p> </p>
        <p>
          Héctor Rubio, Coordinador de Innovación e Incidencia de la
          organización Acción Frente a la Pobreza, comentó que se trató
          únicamente de un discurso y “no hubo un compromiso del gobierno por
          garantizar elecciones libres y hay un uso sistemático de la política
          social y los programas sociales con fines electorales”.
        </p>
        <p> </p>
        <p>
          Pese al aplastante triunfo de la oposición en las pasadas elecciones
          federales,{" "}
          <a target="_blank" href="http://democraciasinpobreza.mx/Informe.pdf">
            una encuesta de la organización
          </a>{" "}
          encontró que el 35.5 % de los mexicanos con credencial de elector
          recibió una oferta de compra de voto, provenientes de la coalición
          Todos por México (PRI, PVEM, Panal) la cual habría ofrecido ayuda al
          5.9 % de los encuestados, seguida de Por México al Frente (PAN, PRD,
          MC) con 5.5 % y Juntos Haremos Historia (Morena, PT y PES) con el  0.7
          %.
        </p>
        <p> </p>
        <p>
          “Todos los partidos políticos incurrieron en esta práctica”, explica
          Héctor Rubio y acusa que durante el gobierno de Peña Nieto no sólo se
          omitió legislar sino que se trató de “maquillar” las cifras de pobreza
          con el uso de “Cartillas Sociales”. “Hay un uso sistemático de la
          política social y los programas sociales con fines electorales”,
          añadió.
        </p>
        <p> </p>
        <ol start="9">
          <li>
            <strong>
              {" "}
              Transparencia y rendición de cuentas y 10. Federalismo y
              transparencia
            </strong>
          </li>
        </ol>
        <p> </p>
        <p>
          Casi al final del manifiesto, Peña Nieto colocó dos puntos:
          “Transparencia y rendición de cuentas” y “Federalismo y
          transparencia”. En ellos, dijo que impulsaría la creación de una
          Comisión Nacional Anticorrupción, iniciativa que no fue aprobada por
          el Congreso pero derivó, explica Max Kaiser, director anticorrupción
          del Instituto Mexicano para la Competitividad, en el el Sistema
          Nacional Anticorrupción.
        </p>
        <p> </p>
        <p>
          Dentro del mismo punto, el presidente dijo que seleccionaría a
          colaboradores “a partir de su capacidad, experiencia y honestidad, no
          de sus relaciones familiares o de amistad”. Pero en la opinión de
          Káiser, el mérito profesional y académico “nunca fue el elemento
          central en las designaciones de los altos cargos. Menos en el caso de
          autoridades fiscalizadores, de temas de justicia, de autoridades
          auditoras”.
        </p>
        <p> </p>
        <p>
          También, Peña Nieto señaló que iba a acelerar “la plena implementación
          de las reformas constitucionales en materia de transparencia y
          homologación contable en los estados y municipios”. Ambas acciones se
          lograron, al menos en el papel.
        </p>
        <p> </p>
        <p>
          De acuerdo{" "}
          <a
            target="_blank"
            href="https://www.animalpolitico.com/2018/07/sistema-nacional-anticorrupcion-estados/"
          >
            “Diagnóstico sobre el grado de armonización de las leyes de los
            sistemas estatales anticorrupción respecto de la Ley General del
            Sistema Nacional Anticorrupción”
          </a>, realizado por la Secretaría Ejecutivo del Sistema Nacional”,
          sólo 15 de las 32 entidades armonizaron los objetivos de la ley con la
          legislación local. <br />
          <br />
        </p>
        <p>
          Las mejoras al respecto de transparencia y corrupción, explica Kaiser,
          “sucedieron porque hubo un empuje histórico desde la sociedad civil
          organizada. Por primera vez en la historia el gobierno tuvo que
          enfrentar una sociedad civil organizada que ponía contenidos, y
          productos completos y acabados, leyes completas”.
        </p>
      </div>
    )
  }
  */
];

export function getBySlug(slug) {
  var post;
  for (var i = 0; i < Posts.length; i++) {
    var p = Posts[i];
    if (p.slug == slug) {
      post = p;
    }
  }
  return post;
}

export default Posts;



// WEBPACK FOOTER //
// ./src/functions/posts.js